import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Location Details',
    label: 'ข้อมูลสถานที่สอบ',
    path: '/admin/exam-location/locations/:roomId',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW],
  },
  {
    value: 'Exam Location Access Requests',
    label: 'สิทธิ์การใช้งาน',
    path: '/admin/exam-location/locations/:roomId/usage',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW],
  },
];

export default function AdminExamLocationDetailNavigationTabs() {
  const { permissions } = usePermission();
  const tabItems = useMemo(
    () =>
      TAB_ITEMS.filter(({ requiredPermission }) => {
        return (
          !requiredPermission?.length ||
          requiredPermission.every((permission) => permissions.includes(permission))
        );
      }),
    [permissions],
  );

  return <NavigationTabs shouldReplace={true} items={tabItems} />;
}
